<!-- eslint-disable @angular-eslint/template/conditional-complexity -->
<div id="header__top-bg" class="header__top-bg">
  <div class="header__top d-lg-flex d-md-none d-none container">
    <div class="header__country-selector">
      <app-country-select />
    </div>
    <div class="header__login-button">
      <span class="header__login-sf" i18n="@@soldByScalefast">Sold by Scalefast</span>
      @if (isFrenchRegion) {
        <span class="header__login-sf"
          ><a target="_blank" [href]="serviceClientIO2Url" i18n="@@serviceClientIO2">SERVICE CLIENT IO2</a></span
        >
      }

      @if (serviceUrl) {
        <span class="header__login-sf"><a target="_blank" [href]="serviceUrl" i18n="@@serviceContact">SERVICE</a></span>
      }
      <app-login-button [showAssociatedText]="true" />
    </div>
  </div>
</div>
<div id="site_header">
  <div id="header__site" class="header" [ngClass]="{ sticky: isSticky }">
    <div class="container-fluid header__bottom">
      <div class="header__content">
        <div class="logo_container">
          <div class="logo">
            <a [routerLink]="['/']">
              @if (router.url === '/') {
                <h1 class="sr-only">Oral-B Store</h1>
              }
              <!--
              This image is configured to be loaded with different sizes depending on the screen width and the pixel density
              The sizes attribute is used to define the width of the image in different scenarios
              The srcset attribute is used to define the image source for different scenarios (74w and 119w for pixel density 1x and 148w and 238w for pixel density 2x)
              -->
              <img
                data-testid="header-logo"
                sizes="(max-width: 991.9px) 75px, 119px"
                alt="Oral-B Store icon"
                title="Oral-B Store"
                [srcset]="
                  ('assets/images/site-logo_75_25.webp' | staticFileHash) +
                  ' 75w, ' +
                  ('assets/images/site-logo_149_50.webp' | staticFileHash) +
                  ' 149w, ' +
                  ('assets/images/site-logo_119_40.webp' | staticFileHash) +
                  ' 119w, ' +
                  ('assets/images/site-logo_238_80.webp' | staticFileHash) +
                  ' 238w'
                "
                [src]="'assets/images/site-logo_75_25.webp' | staticFileHash"
              />
            </a>
          </div>
        </div>
        <div class="header__nav container-fluid">
          <app-store-nav
            [isMobileOpen]="isMobileOpen"
            [isSticky]="isSticky"
            [headerTop]="headerTop"
            (backdropClick)="listenBackdropClick($event)"
          />
        </div>
        <div id="top_links">
          <div class="item-links">
            <div class="item-link">
              <app-search-modal />
            </div>

            <div class="item-link">
              <app-minicart-offcanvas />
            </div>

            <div class="header-menu-button item-link d-lg-none col">
              <button
                id="dropdown-menu-mobile"
                type="button"
                class="btn btn-icon navbar-toggle"
                aria-label="Close menu"
                aria-controls="primary_nav"
                [ngClass]="{ open: isMobileOpen }"
                (click)="clickMenu()"
                (onKeyDown)="clickMenu()"
              >
                <i></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
